const LaptopCheckIcon = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1694_879)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 2.5V8H10V2.5H2ZM1 2.0035C1 1.7255 1.2275 1.5 1.496 1.5H10.504C10.778 1.5 11 1.7245 11 2.0035V9H1V2.0035ZM0.5 9.5H11.5V10.5H0.5V9.5ZM8.08773 5.05926L7.0415 3.75146L5.50004 5.29292L4.00004 3.79292L2.64648 5.14648L3.35359 5.85358L4.00004 5.20714L5.50004 6.70714L6.95858 5.2486L7.91234 6.4408L9.30004 5.40003L8.70004 4.60003L8.08773 5.05926Z" fill="#9499AA"/>
    </g>
    <defs>
    <clipPath id="clip0_1694_879">
    <rect width="12" height="12" fill="white"/>
    </clipPath>
    </defs>
  </svg>
);

export default LaptopCheckIcon;
